<template lang="pug">
    v-menu(
      ref='menu'
      :close-on-content-click='false'
      :return-value.sync='propRange'
      transition='scale-transition'
      offset-y=''
      max-width='290px'
      min-width='290px'
    )
      template(v-slot:activator='{ on }')
        v-text-field(
          v-model='daterange'
          :label='label'
          prepend-icon='event'
          readonly=''
          v-on='on'
        )
      v-date-picker(
        v-model='propRange'
        no-title
        range
        scrollable
        @input="pick"
      )
</template>

<script>
import moment from 'moment';

export default {
  name: 'DateRangePicker',
  props: {
    label: {
      type: String,
      default: '',
    },
    range: {
      type: Array,
      default: () => [
        moment().format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],
    },
  },
  data() {
    return {
      propRange: this.range,
      menu: false,
    };
  },
  model: {
    prop: 'range',
  },
  computed: {
    daterange() {
      return this.propRange.join(' - ');
    },
  },
  methods: {
    update(range) {
      this.$refs.menu.save(range);
      this.$emit('input', range);
    },
    pick(input) {
      if (input.length > 1) {
        this.menu = false;
        this.update(this.propRange);
      }
    },
  },
};
</script>

<style>

</style>
